import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import { H5 } from 'UIComponents/elements/headings';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import UILoadingDots from 'UIComponents/loading/UILoadingDots';
import UIList from 'UIComponents/list/UIList';
import { useTargetHubs } from '../../hooks/queries/use-target-hubs';
import { useAssetCopierContext } from '../providers/AssetCopierProvider';
import DestinationAccountNotAllowedTooltip from '../common/DestinationAccountNotAllowedTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function ChooseDestination() {
  const {
    setSelectedTargetHub,
    selectedTargetHub
  } = useAssetCopierContext();
  const {
    targetHubs,
    loading
  } = useTargetHubs();
  const sortedHubs = useMemo(() => {
    return targetHubs.sort((a, b) => {
      if (a.enabled && !b.enabled) {
        return -1;
      }
      if (!a.enabled && b.enabled) {
        return 1;
      }
      return 0;
    });
  }, [targetHubs]);
  if (loading) {
    return /*#__PURE__*/_jsx(UILoadingDots, {});
  }
  if (sortedHubs.length === 0) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-multi-account-asset-copier.panel.chooseDestination.noAccounts.title"
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ui-multi-account-asset-copier.panel.chooseDestination.noAccounts.reason"
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(UIList, {
        styled: true,
        className: "p-left-3",
        children: [/*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ui-multi-account-asset-copier.destinationAccountNotAllowed.superAdmin"
          })
        }), /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ui-multi-account-asset-copier.destinationAccountNotAllowed.enterpriseSubscription"
          })
        }), /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ui-multi-account-asset-copier.destinationAccountNotAllowed.differentLocation"
          })
        }), /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ui-multi-account-asset-copier.destinationAccountNotAllowed.sandboxAccount"
          })
        })]
      })]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ui-multi-account-asset-copier.panel.chooseDestinationTitle"
      })
    }), /*#__PURE__*/_jsx(UIToggleGroup, {
      name: "description-example",
      children: sortedHubs.map(hub => /*#__PURE__*/_jsx(DestinationAccountNotAllowedTooltip, {
        disabled: hub.enabled,
        children: /*#__PURE__*/_jsx(UIRadioInput, {
          description: /*#__PURE__*/_jsx(Small, {
            use: "help",
            children: hub.hubId
          }),
          onChange: () => setSelectedTargetHub(hub),
          disabled: !hub.enabled,
          "data-test-id": "destination-radio-input",
          checked: hub.hubId === (selectedTargetHub === null || selectedTargetHub === void 0 ? void 0 : selectedTargetHub.hubId),
          children: hub.name
        })
      }, hub.hubId))
    })]
  });
}
export default ChooseDestination;